<template>
    <div class="row">
        <div class="col-12">
            <div class="card mb-4">
                <div class="card-header pb-0">
                    <sub-retailer-user-nav />
                </div>
                <hr class="horizontal dark" />
                <div class="card-header py-0">
                    <sub-retailer-user-header />
                </div>
                <hr class="horizontal dark mt-3" />
                <div class="card-body px-0 pt-0 pb-2">
                    <sub-retailer-user-list />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import header from './components/header.vue';
import nav from './components/nav.vue';
import subRetailerUserList from "./components/subRetailerUserList.vue";

export default {
    components: {
        "sub-retailer-user-header": header,
        "sub-retailer-user-nav": nav,
        "sub-retailer-user-list": subRetailerUserList,
    },
};
</script>